var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabOv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 763,
    viewBox: "0 0 834 763",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.313 -9.33806C831.955 -17.4924 834.058 -28.9225 829.815 -39.3501C823.627 -54.5611 806.28 -61.8774 791.066 -55.6883C780.641 -51.4471 773.924 -41.9625 772.722 -31.5141C764.568 -38.1564 753.138 -40.2585 742.712 -36.0173C727.499 -29.8282 720.185 -12.4792 726.373 2.73172C730.615 13.1593 740.1 19.8757 750.548 21.0771C743.905 29.2291 741.803 40.6593 746.045 51.0868C752.233 66.2978 769.58 73.6142 784.794 67.4251C795.22 63.1838 801.936 53.6992 803.139 43.2531C811.292 49.8932 822.722 51.9953 833.148 47.754C848.362 41.5649 855.675 24.216 849.487 9.00502C845.245 -1.42253 835.76 -8.139 825.313 -9.33806ZM792.393 16.8388C787.981 13.246 782.611 10.9818 776.956 10.3339C780.552 5.92064 782.816 0.550673 783.467 -5.10202C787.88 -1.50925 793.25 0.754957 798.905 1.4051C795.308 5.8161 793.044 11.1861 792.393 16.8388Z",
    fill: "#FF7506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.182 -60.3198C806.954 -67.5494 827.218 -59.003 834.447 -41.2346C838.369 -31.594 837.644 -21.2241 833.334 -12.602C842.439 -9.43819 850.197 -2.51966 854.119 7.12037C861.347 24.889 852.804 45.1558 835.032 52.3856C825.393 56.3071 815.023 55.5821 806.401 51.2733C803.236 60.377 796.318 68.1353 786.678 72.0567C768.907 79.2865 748.642 70.7392 741.413 52.9706C737.492 43.3308 738.215 32.9615 742.525 24.3405C733.42 21.1754 725.663 14.2558 721.742 4.61562C714.513 -13.153 723.057 -33.419 740.828 -40.6487C750.467 -44.57 760.837 -43.8455 769.459 -39.536C772.623 -48.6408 779.543 -56.3985 789.182 -60.3198ZM786.73 2.91836C786.236 4.33775 785.652 5.72401 784.98 7.06821C786.399 7.56125 787.785 8.14547 789.129 8.81709C789.623 7.39801 790.207 6.01201 790.879 4.66815C789.46 4.17481 788.074 3.59022 786.73 2.91836Z",
    stroke: "white",
    strokeWidth: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-75.626 190.654C-68.3221 174.089 -50.8784 163.89 -32.8701 165.881C-12.6239 168.121 2.91377 184.72 4.17285 204.759C11.1787 208.894 18.7705 212.071 26.6094 214.792L33.4111 216.701C42.4156 206.704 56.0552 201.488 69.5049 203.225C98.9764 207.032 115.134 239.359 100.558 265.256C91.0782 282.097 70.7878 290.115 52.3721 284.673L52.2803 284.647L52.1904 284.614L47.8975 283.042L47.5791 282.924L47.2949 282.74C46.8604 282.458 46.3665 282.2 45.7451 281.893C45.1682 281.608 44.4176 281.25 43.708 280.848C30.8557 273.573 22.8951 259.601 22.7139 244.994C22.1302 244.704 21.5705 244.433 21.4014 244.352C12.5915 240.161 2.99303 237.21 -6.65039 235.494C-6.8085 235.672 -6.96556 235.852 -7.11816 236.026C-7.21934 236.141 -7.32185 236.257 -7.41309 236.358C-7.49556 236.45 -7.6046 236.571 -7.71094 236.677L-7.71191 236.678C-17.6937 246.683 -32.0008 251.161 -45.9541 248.18C-46.5995 248.042 -47.2733 247.854 -47.75 247.73C-48.2805 247.592 -48.6878 247.499 -49.0596 247.451L-49.3906 247.408L-49.7041 247.293L-53.7441 245.813L-54.0928 245.685L-54.3994 245.477C-54.6625 245.298 -54.9874 245.125 -55.4541 244.901C-55.8598 244.706 -56.4979 244.415 -57.0654 244.108V244.109C-72.6443 235.686 -81.3426 218.163 -78.4482 200.63L-78.4395 200.571L-78.4268 200.512L-77.4316 195.687L-77.3721 195.401L-77.2598 195.131C-77.014 194.546 -76.8036 193.91 -76.542 193.124C-76.2958 192.384 -76.001 191.504 -75.626 190.654Z",
    fill: "#FF7506",
    stroke: "#FAFAFA",
    strokeWidth: 6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.936 640.278L158.834 642.646C160.182 644.708 161.471 646.332 161.886 648.833C163.115 656.381 154.958 667.774 150.742 673.703C150.224 674.42 149.556 675.466 149.191 676.273L144.858 681.547C144.421 682.034 144.052 682.599 143.596 683.082C132.042 695.501 117.355 701.892 100.49 696.62C79.0718 689.934 68.7261 667.597 74.8942 646.764C77.8708 636.711 87.5349 623.294 94.0098 614.864C98.6894 608.791 104.728 602.154 112.972 606.667C121.204 611.181 121.923 619.669 117.753 627.227C113.094 635.656 106.011 643.448 101.831 652.09C97.9054 660.192 102.178 671.688 112.156 672.13C122.089 672.57 130.411 656.287 135.897 649.365C140.585 643.442 147.726 635.057 155.936 640.279L155.936 640.278Z",
    fill: "#F9B634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8926 698.528C77.3326 691.486 66.529 667.974 72.9767 646.196C74.5459 640.897 77.8278 634.839 81.4519 629.133C84.64 624.113 88.159 619.263 91.1681 615.292L92.424 613.645L92.4253 613.644C94.7604 610.613 97.6441 607.147 101.134 605.076C102.913 604.021 104.903 603.293 107.098 603.193C109.304 603.092 111.588 603.629 113.933 604.913L113.933 604.914C118.535 607.437 121.172 611.174 121.978 615.434C122.773 619.63 121.755 624.115 119.504 628.193L119.503 628.195C117.108 632.527 114.095 636.688 111.247 640.73C108.368 644.817 105.641 648.804 103.631 652.961L103.631 652.962C101.943 656.445 102.008 660.715 103.594 664.142C105.156 667.516 108.116 669.949 112.245 670.132C114.147 670.216 116.102 669.509 118.143 668.09C120.19 666.667 122.198 664.614 124.148 662.239C126.092 659.872 127.915 657.265 129.62 654.775C131.299 652.323 132.902 649.924 134.329 648.123L135.238 646.985C137.448 644.25 140.263 641.05 143.514 638.96C145.399 637.749 147.525 636.845 149.848 636.668C151.366 636.553 152.906 636.754 154.449 637.317L154.583 636.59L157.201 638.729L160.099 641.097L160.339 641.292L160.509 641.552C161.741 643.438 163.358 645.485 163.859 648.505L163.86 648.511C164.59 652.998 162.545 658.259 160.121 662.815C157.638 667.48 154.469 671.913 152.372 674.862L152.368 674.868L152.363 674.874C151.878 675.545 151.299 676.466 151.014 677.096L150.905 677.338L150.737 677.542L146.403 682.817L146.376 682.849L146.347 682.881C146.187 683.06 146.034 683.259 145.814 683.542C145.612 683.802 145.352 684.135 145.05 684.455L145.049 684.455C133.137 697.253 117.694 704.093 99.8926 698.528Z",
    stroke: "white",
    strokeWidth: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765.686 564.012C767.302 563.778 769.788 563.635 772.114 565.148C773.99 566.37 774.947 568.18 775.476 569.382L775.678 569.856C777.115 573.321 778.021 578.171 778.678 581.371L778.946 582.633V582.634C782.203 597.313 784.517 611.18 788.123 625.273C788.733 627.657 789.497 630.07 790.31 632.81C791.092 635.449 791.893 638.313 792.397 641.162C792.703 642.895 793.217 645.876 792.685 648.743C792.398 650.288 791.775 652.026 790.49 653.587C789.521 654.765 788.318 655.666 786.951 656.306L786.154 657.134H781.589L781.154 657.063L746.606 651.49L746.508 651.474L746.41 651.455C740.108 650.204 733.657 649.275 726.982 648.245C720.374 647.226 713.599 646.115 706.974 644.52V644.519C706.012 644.288 702.82 643.772 700.325 641.938L698.082 640.29V635.969L698.231 635.343C701.266 622.556 705.952 610.202 714.003 599.16C725.175 583.839 739.595 573.051 757.411 566.575L759.059 565.968C759.705 565.73 760.418 565.472 761.105 565.237C762.421 564.787 764.165 564.233 765.686 564.013V564.012Z",
    fill: "#FBB733",
    stroke: "white",
    strokeWidth: 11
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 714.171,
    y: -67.891,
    width: 151.604,
    height: 151.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.08565,
    dy: 4.08565
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: -82.0005,
    y: 162.634,
    width: 194.005,
    height: 132.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 69.134,
    y: 601.18,
    width: 99.8755,
    height: 109.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 692.582,
    y: 558.366,
    width: 109.831,
    height: 113.268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 105,
    fill: "white",
    transform: "translate(692 558)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabOv);
export default __webpack_public_path__ + "static/media/tab-ov.1098e047496a3a995483e4f0439dd840.svg";
export { ForwardRef as ReactComponent };